var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SnippetHelper } from './SnippetHelper';
import { DateUtils } from './DateUtils';
import { LanguageHelper } from './LanguageHelper';
import { Utils } from './Utils';
var EventPageHelper = (function () {
    function EventPageHelper() {
    }
    EventPageHelper.initialize = function () {
        return __awaiter(this, void 0, void 0, function () {
            var backSnippet, backLinks, i, dateDom, startDateDom, endDateDom, allDayDom, allDay, dateHTML, startDate, startTime, endDate, endTime, today, checkEndDate, regButton, contentDoms, parentDom, buttonDom, externalLinkDom, linkParentDom, cDom, pDom;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // get admin snippets for localized text and inject into dom
                        SnippetHelper.locSnippet("#backToEvents", "back-text-1");
                        SnippetHelper.locSnippet("#backToEvents", "back-text-2");
                        SnippetHelper.locSnippet("#eventInformation", "event-info");
                        SnippetHelper.locSnippet("#tagsHeading", "tags-heading");
                        return [4 /*yield*/, SnippetHelper.getSnippet("#backToEvents")];
                    case 1:
                        backSnippet = _a.sent();
                        backLinks = document.querySelectorAll(".back-link");
                        for (i = 0; i < backLinks.length; i++) {
                            if (backSnippet[0].url.url) {
                                backLinks[i].setAttribute("href", backSnippet[0].url.url);
                            }
                        }
                        dateDom = document.getElementById("eventDates");
                        startDateDom = document.getElementById("eventStart");
                        endDateDom = document.getElementById("eventEnd");
                        allDayDom = document.getElementById("eventAllDay");
                        allDay = false;
                        today = new Date();
                        if (allDayDom.textContent.trim() == "Yes") {
                            allDay = true;
                        }
                        if (!startDateDom) return [3 /*break*/, 6];
                        return [4 /*yield*/, DateUtils._formatDate(startDateDom.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "LL")];
                    case 2:
                        // console.log("inside EventPageHelper - startDateDom", startDateDom);
                        // console.log("inside EventPageHelper, startDateDom.textContent.trim()", startDateDom.textContent.trim());
                        // console.log("inside EventPageHelper, LanguageHelper.getCurrentLocale()", LanguageHelper.getCurrentLocale());
                        // console.log("inside EventPageHelper, LanguageHelper.getCurrentLocale().Locale", LanguageHelper.getCurrentLocale().Locale);
                        // startDate = await DateUtils._formatDate(startDateDom.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "LL");
                        // startTime = await DateUtils._formatDate(startDateDom.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "LT");
                        startDate = _a.sent();
                        if (!allDay) return [3 /*break*/, 3];
                        startTime = "";
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, DateUtils._formatDate(startDateDom.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "LT")];
                    case 4:
                        //******  can't get LT to show time properly - keeps coming out as 12:00 AM
                        startTime = _a.sent();
                        _a.label = 5;
                    case 5:
                        console.log("inside EventPageHelper - startDate formatted, startTime formatted", startDate, startTime);
                        _a.label = 6;
                    case 6:
                        if (!endDateDom) return [3 /*break*/, 11];
                        return [4 /*yield*/, DateUtils._formatDate(endDateDom.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "LL")];
                    case 7:
                        // console.log("inside EventPageHelper - endDateDom", endDateDom);
                        endDate = _a.sent();
                        if (!allDay) return [3 /*break*/, 8];
                        endTime = "";
                        return [3 /*break*/, 10];
                    case 8: return [4 /*yield*/, DateUtils._formatDate(endDateDom.textContent.trim(), LanguageHelper.getCurrentLocale().Locale, "h:mm A")];
                    case 9:
                        //******  can't get LT to show time properly - keeps coming out as 12:00 AM		
                        endTime = _a.sent();
                        _a.label = 10;
                    case 10:
                        checkEndDate = new Date(endDateDom.textContent.trim());
                        if (checkEndDate >= today) {
                            regButton = document.getElementById("registerButton");
                            if (regButton) {
                                regButton.setAttribute("style", "");
                            }
                        }
                        _a.label = 11;
                    case 11:
                        // if no end date, also unhide reg button
                        if (!endDate) {
                            regButton.setAttribute("style", "");
                        }
                        // console.log("inside EventPageHelper - locale? ", LanguageHelper.getCurrentLocale().Locale);
                        if (startDate && endDate) {
                            if (startDate == endDate) {
                                dateHTML = "<span id='eventDateStamp'>" + startDate + " " + startTime;
                                if (!allDay) {
                                    dateHTML += " - " + endTime;
                                }
                                dateHTML += "</span>";
                            }
                            else {
                                dateHTML = "<span id='eventDateStamp'>" + startDate + " " + startTime + " - ";
                                if (!allDay) {
                                    dateHTML += "<br />";
                                }
                                dateHTML += endDate + " " + endTime + "</span>";
                            }
                        }
                        else if (startDate && !endDate) {
                            dateHTML = "<span id='eventDateStamp'>" + startDate;
                            if (!allDay) {
                                dateHTML += " " + startTime;
                            }
                            dateHTML += "</span>";
                        }
                        // add processed date to dom
                        dateDom.innerHTML = dateHTML;
                        // email processing
                        Utils.processMailto("eventMailto", "eventEmail");
                        contentDoms = ["ttContactName", "ttContactTitle", "ttContactPhone"];
                        parentDom = "ttContactSection";
                        if (Utils.checkForContent(contentDoms, parentDom) === true) {
                            document.getElementById(parentDom).style.display = "block";
                        }
                        buttonDom = ["registerButton"];
                        externalLinkDom = ['externalLink'];
                        linkParentDom = "ttDetailSection";
                        if (Utils.checkForContent(buttonDom, linkParentDom) === true) {
                            document.querySelector('#registerButton a').setAttribute("target", "_blank");
                        }
                        if (Utils.checkForContent(externalLinkDom, linkParentDom) === true) {
                            document.querySelector("#externalLink a").setAttribute("target", "_blank");
                        }
                        cDom = "ttTagsHidden";
                        pDom = "ttTagSection";
                        setTimeout(function () {
                            Utils.tagSectionCheck(cDom, pDom);
                        }, 3000);
                        return [2 /*return*/];
                }
            });
        });
    };
    return EventPageHelper;
}());
export { EventPageHelper };

//# sourceMappingURL=EventPageHelper.js.map
